export var IGetAchMessagingResponse;
(function (IGetAchMessagingResponse) {
    /**
     * The page where the banner should appear
     */
    let AchBannerSurface;
    (function (AchBannerSurface) {
        AchBannerSurface["ACH_BANNER_SURFACE_UNKNOWN"] = "ACH_BANNER_SURFACE_UNKNOWN";
        AchBannerSurface["ORDERS"] = "ORDERS";
        AchBannerSurface["POST_ORDERS"] = "POST_ORDERS";
        AchBannerSurface["INVOICES"] = "INVOICES";
        AchBannerSurface["ACCOUNT_SETTINGS"] = "ACCOUNT_SETTINGS";
    })(AchBannerSurface = IGetAchMessagingResponse.AchBannerSurface || (IGetAchMessagingResponse.AchBannerSurface = {}));
    let AchOfferType;
    (function (AchOfferType) {
        AchOfferType["ACH_OFFER_TYPE_UNKNOWN"] = "ACH_OFFER_TYPE_UNKNOWN";
        AchOfferType["PROACTIVE_LIMIT_INCREASE"] = "PROACTIVE_LIMIT_INCREASE";
        /**
         * Requires linking ACH to claim terms offer
         */
        AchOfferType["TERMS_PRE_APPROVAL_ACH_LINK"] = "TERMS_PRE_APPROVAL_ACH_LINK";
        AchOfferType["TERMS_PRE_APPROVAL"] = "TERMS_PRE_APPROVAL";
    })(AchOfferType = IGetAchMessagingResponse.AchOfferType || (IGetAchMessagingResponse.AchOfferType = {}));
    let IBannerData;
    (function (IBannerData) {
        /**
         * Return an instance of IBannerData with the provided fields. Any field not
         * listed will be populated with an empty value (an empty array,
         * or undefined, whichever is valid for the type of the value.)
         */
        IBannerData.build = (partial) => (Object.assign({}, (partial !== null && partial !== void 0 ? partial : {})));
    })(IBannerData = IGetAchMessagingResponse.IBannerData || (IGetAchMessagingResponse.IBannerData = {}));
    /**
     * Return an instance of IGetAchMessagingResponse with the provided fields. Any field not
     * listed will be populated with an empty value (an empty array,
     * or undefined, whichever is valid for the type of the value.)
     */
    IGetAchMessagingResponse.build = (partial) => (Object.assign({}, (partial !== null && partial !== void 0 ? partial : {})));
})(IGetAchMessagingResponse || (IGetAchMessagingResponse = {}));
